import React from "react";
import { motion } from "framer-motion";
import { maintenanceContainer, maintenancePage } from "./maintenanceTheme";

/**
 * Page shell aligned with Import Reports (ReportPageLayout).
 */
const MaintenancePageLayout = ({ children }) => (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={maintenancePage}
    >
        <div className={maintenanceContainer}>{children}</div>
    </motion.div>
);

export default MaintenancePageLayout;
